import { atom } from 'jotai'
import { UserInvitationDomains } from 'sierra-domain/api/manage'

/*
 * Available user attributes for invitation
 * */
export const userInvitationDomainsAtom = atom<UserInvitationDomains | undefined>(undefined)
